// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Pnvk","title":"Images90_title__27wlv","images":"Images90_images__3Qxyc"};